<template>
  <span class="badge badge-glow" :style="badgeStyle">
    <slot>{{ label }}</slot>
  </span>
</template>

<script>
import { $themeColors } from '@themeConfig'

export default {
  name: 'HandlingStatusBadge',
  props: {
    label: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: null
    }
  },
  computed: {
    badgeStyle() {
      const resolvedColor = this.resolveColor(this.color)
      return {
        backgroundColor: resolvedColor,
        color: '#fff'
      }
    }
  },
  methods: {
    resolveColor(colorName) {
      if (
        colorName &&
        typeof colorName === 'string' &&
        colorName.startsWith('#')
      ) {
        return colorName
      }

      const colorMap = {
        primary: $themeColors.primary || '#7367F0',
        info: $themeColors.info || '#00CFE8',
        warning: $themeColors.warning || '#FF9F43',
        danger: $themeColors.danger || '#EA5455',
        success: $themeColors.success || '#28C76F',
        dark: $themeColors.dark || '#4B4B4B',
        secondary: $themeColors.secondary || '#82868B',
        grey: $themeColors.secondary || '#82868B'
      }

      return (
        colorMap[colorName] || $themeColors[colorName] || colorName || '#5E50EE'
      )
    }
  }
}
</script>

<style scoped></style>
